import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ColorInput } from '@mantine/core';
import AppStack from '../../common/AppStack';
import ResponsiveModal from '../../common/ResponsiveModal';

const SetVariantColorsModal = ({ isOpen, onClose, onConfirm }) => {
  const [formState, setFormState] = useState({
    primaryColor: '',
    secondaryColor: ''
  });

  return (
    <ResponsiveModal
      formSectionProps={{
        onCancel: onClose,
        onSubmit: () => {
          onConfirm({
            primaryColor: formState.primaryColor,
            secondaryColor: formState.primaryColor
              ? formState.secondaryColor
              : ''
          });
        },
        cancelTitle: 'Close',
        submitTitle: 'Confirm'
      }}
      isOpen={isOpen}
      onClose={onClose}
      title="Set variant colors"
    >
      <AppStack style={{ gap: 16 }}>
        <ColorInput
          label="Primary color"
          onChange={(value) =>
            setFormState({ ...formState, primaryColor: value })
          }
          value={formState.primaryColor}
        />

        {formState.primaryColor && (
          <ColorInput
            label="Secondary color"
            onChange={(value) =>
              setFormState({ ...formState, secondaryColor: value })
            }
            value={formState.secondaryColor}
          />
        )}
      </AppStack>
    </ResponsiveModal>
  );
};

SetVariantColorsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default SetVariantColorsModal;
